import { PRODUCT_URL, PRODUCT_APP_ID, PRODUCT_APP_SECRET, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const productAxiosInstaceV1 = axios.create({
    baseURL: `${PRODUCT_URL}/api/v1`,
    headers: {
        'app-id': PRODUCT_APP_ID,
        'app-secret': PRODUCT_APP_SECRET
    }
})
productAxiosInstaceV1.interceptors.response.use(function (response) {
    if (response.data.redirect_to) {
        location.href = response.data.redirect_to
    }
    return response
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
        EventBus.$emit('unauthorized')
    }
    if (error.response.status !== 404) {
        EventBus.$emit('show-error-modal', error)
    }
    return Promise.reject(error)
})
export const ProductAPI = {

    /**
     * get brand list
     * @param null
     * @returns {Promise}
     */
    list() {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Insert data
     */
    insert(collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Edit data
     */
    edit(id, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${id}`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Delete api
     */
    delete(id) {
        return productAxiosInstaceV1({
            method: 'delete',
            url: `/products/${id}`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Fetcch product images
     */
    fetchImages(id) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${id}/images`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Add new product image
     */
    addImage(id, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${id}/addImage`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sort product image
     */
    updateSort(collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/image/updateSort`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Update product image to default
     */
    updateImageDefault(pid, imageId, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/updateImage/${imageId}`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Delete product Image
     */
    deleteProductImage(pid, imageId) {
        return productAxiosInstaceV1({
            method: 'delete',
            url: `/products/${pid}/image/${imageId}`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Fetch product detail by product Id
     */
    fetchProductDetail(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Cannabis attributes
     * ==================
     */

    /**
     * Fetch cannabis attributes
     */
    fetchCannabisAttributes(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/cannabis_attributes`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     *  Insert cannabis attributes
     */
    insertCannabisAttributes(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/cannabis_attributes`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     *  Edit cannabis attributes
     */
    editCannabisAttributes(pid, collection) {
        return productAxiosInstaceV1({
            method: 'put',
            url: `/products/${pid}/cannabis_attributes`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     *  Delete cannabis attributes
     */
    deleteCannabisAttributes(pid) {
        return productAxiosInstaceV1({
            method: 'delete',
            url: `/products/${pid}/cannabis_attributes`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Terpene
     * ==================
     */

    /**
     * Fetch product terpene
     */

    fetchSyncedTerpenes(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getTerpenes`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product terpene
     */
    syncTerpenes(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncTerpenes`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Aroma
     * ==================
     */

    /**
     * Fetch product aroma
     */

    fetchSyncedAromas(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getAromas`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product terpene
     */
    syncAromas(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncAromas`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Colour
     * ==================
     */

    /**
     * Fetch product colour
     */
    fetchSyncedColours(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getColours`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product colour
     */
    syncColours(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncColours`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Flavours
     * ==================
     */

    /**
     * Fetch sync flavours
     */
    fetchSyncedFlavours(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getFlavours`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product colour
     */
    syncFlavours(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncFlavours`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Moods
     * ==================
     */

    /**
     * Fetch synced moods
     */
    fetchSyncedMoods(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getMoods`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product moods
     */
    syncMoods(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncMoods`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * ==================
     *  Allergens
     * ==================
     */

    /**
     * Fetch synced allergens
     */
    fetchSyncedAllergens(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/products/${pid}/getAllergens`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Sync product moods
     */
    syncAllergens(pid, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/products/${pid}/syncAllergens`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },
    /**
     * ==================
     *  CBD /THC
     * ==================
     */

    /**
     * Fetch THC / CBD
     */
    fetchCBDTHC(pid) {
        return productAxiosInstaceV1({
            method: 'get',
            url: `/productThcCbdLevels/${pid}/getByProduct`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Insert THC / CBD
     */
    insertCBDTHC(collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/productThcCbdLevels`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Edit THC / CBD
     */
    editCBDTHC(id, collection) {
        return productAxiosInstaceV1({
            method: 'post',
            url: `/productThcCbdLevels/${id}`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Delete edit THC / CBD
     */
    deleteCBDTHC(id) {
        return productAxiosInstaceV1({
            method: 'delete',
            url: `/productThcCbdLevels/${id}`,
            headers: {
                'auth-token': authToken()
            }
        })
    }
}
